<template>
  <div class="w-100 d-flex justify-content-between">
    <b-form-input
      v-if="!editable"
      :class="!editable ? 'isNotDisabled' : 'isDisabled'"
      class="custom-input-obj"
      id="myURL"
      name="myURL"
      type="url"
      v-model.lazy.trim="valueHandler"
      :state="this.$props.state"
      :placeholder="this.$props.placeholder ? this.$props.placeholder : 'LINK'"
    />
    <a v-if="editable" @click="onWindowsOpen()" class="h-100 w-100 lowercase">
      {{ this.$props.value }}
    </a>
    <img
      v-if="!editable"
      src="@/assets/icons/trash-can-outline-edit.svg"
      class="custom-img"
      @click="onActionEditHandler(true)"
    />
    <img
      v-if="editable"
      src="@/assets/icons/pencil-outline.svg"
      class="custom-img"
      @click="onActionEditHandler(false)"
    />
  </div>
</template>

<script>
export default {
  props: [
    "value",
    "onChangedValue",
    "state",
    "placeholder",
    "onActionEdit",
    "onlyRead",
  ],
  async mounted() {
    this.valueHandler = this.$props.value;
  },
  watch: {
    valueHandler: {
      handler() {
        if (this.$props.onChangedValue)
          this.$props.onChangedValue(this.valueHandler);
      },
    },
    value: {
      handler() {
        this.valueHandler = this.$props.value;
      },
    },
    onlyRead: {
      handler() {
        this.editable = this.$props.onlyRead;
      },
    },
  },
  data() {
    return {
      valueHandler: null,
      disabled: false,
      editable: true,
    };
  },
  methods: {
    onWindowsOpen() {
      if (this.$props.value != null && this.$props.value != "") {
        window.open(this.$props.value, "_blank");
      }
    },
    onActionEditHandler(value) {
      if (!value) {
        this.valueHandler = "";
      }

      this.editable = value;
      if (this.$props.onActionEdit) this.$props.onActionEdit(value);
    },
  },
};
</script>
<style lang="css" scoped>
input:hover {
  text-decoration: underline;
}
.custom-input-obj {
  margin-right: 1rem;
  width: 100%;
  border: 0 none !important;
  outline: 0;
  color: rgb(0, 153, 93) !important;
}
.custom-img {
  cursor: pointer;
  width: 20px;
}
.isDisabled {
  pointer-events: none;
  cursor: pointer;
  text-decoration: none;
}
.isNotDisabled {
  cursor: auto;
}
.lowercase {
  text-transform: lowercase;
  text-align: right;
  margin-right: 1rem;
  font-size: 1.4rem;
}
</style>
